// Visual semantic meta-token catalog for WORLD COSTA BLANCA.
//
// SOURCE: docs/32-VISUAL-SEMANTIC-META-TOKENS.md (canonical, 2026-08).
// METHOD: IMPLEMENT — P0 token vocabulary mapped to concrete visual params.
// WHY: one shared system produces 5+ visibly different properties
//   (ANTI.clone_house_repetition, ANTI.flat_white_surfaces).
// SCOPE: P0 tokens only (ARCH.*, MATERIAL.*, LANDSCAPE.STYLE, WATER.TYPE,
//   LIGHT.TIME). CAMERA.* is owned by the CameraAuthority, not this catalog.

export const FACADES = {
  'lime-white':   { color: 0xf4efe2, roughness: .95 },
  'crisp-white':  { color: 0xf9faf7, roughness: .55 },
  'warm-plaster': { color: 0xeadfc4, roughness: .9 },
  'stone':        { color: 0xb3a892, roughness: 1 }
};

export const TRIMS = {
  'altea-blue':  { color: 0x2e6f9e, roughness: .7 },
  'dark-wood':   { color: 0x5a4232, roughness: .85 },
  'iron-black':  { color: 0x2b2f33, roughness: .6 },
  'sage-green':  { color: 0x7d9070, roughness: .8 }
};

export const ROOF_MATERIALS = {
  'terracotta':   { color: 0xb5654a, roughness: .85 },
  'gravel-light': { color: 0xd8d2c4, roughness: 1 },
  'deck-wood':    { color: 0xa98a63, roughness: .8 }
};

export const GLASS = { color: 0x2f5a6b, roughness: .18, metalness: .2 };
export const WATER_SURFACE = { color: 0x4fa8b8, roughness: .15, metalness: .1 };

// ARCH.FAMILY values — each maps to a builder in builders/archetypes.js.
export const ARCH_FAMILIES = ['oldtown-house', 'sea-villa', 'family-villa', 'hillside-apartment', 'townhouse'];

// World-level LIGHT.TIME presets (sun/hemisphere/sky tuning).
export const LIGHT_TIMES = {
  'golden-late': { sun: 0xffe9c4, sunIntensity: 3.5, hemiSky: 0xeef6f3, hemiGround: 0x8f765b, hemiIntensity: 2.15, sky: 0xdcecec },
  'midday':      { sun: 0xfff6e8, sunIntensity: 4.2, hemiSky: 0xf2f8f7, hemiGround: 0x9a8568, hemiIntensity: 2.5, sky: 0xe4f0f0 },
  'dusk':        { sun: 0xffc98f, sunIntensity: 2.4, hemiSky: 0xd8dfe6, hemiGround: 0x7a6752, hemiIntensity: 1.6, sky: 0xcfdde2 }
};
